var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJiraOriginalWordmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0115 1.1189H28.8428C28.8428 6.39608 33.115 10.6673 38.3898 10.6673H42.2846V14.4361C42.2846 19.7133 46.5564 23.985 51.8336 23.985V2.94046C51.8331 2.45742 51.6409 1.99432 51.2993 1.6528C50.9577 1.31129 50.4946 1.11927 50.0115 1.1189Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5218 11.6729H18.353C18.353 16.95 22.6229 21.2204 27.9001 21.2204H31.7944V24.99C31.7944 30.2672 36.0662 34.5394 41.3433 34.5394V13.4949C41.343 13.0118 41.1509 12.5487 40.8094 12.2071C40.4679 11.8655 40.0048 11.6733 39.5218 11.6729Z",
    fill: "url(#paint0_linear_516_480)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0315 22.2253H7.86084C7.86084 27.5025 12.1326 31.7743 17.4093 31.7743H21.3046V35.5444C21.3046 40.8197 25.5758 45.0914 30.853 45.0914V24.0474C30.8527 23.5643 30.6606 23.1012 30.3191 22.7596C29.9776 22.418 29.5145 22.2258 29.0315 22.2253Z",
    fill: "url(#paint1_linear_516_480)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5623 47.4572H23.172V55.4165C23.172 57.517 22.2144 58.9819 19.9911 58.9819C19.1567 58.9819 18.5028 58.8426 18.0542 58.6851V57.1598C18.545 57.3576 19.1361 57.4565 19.7276 57.4565C21.0936 57.4565 21.5623 56.6658 21.5623 55.5159V47.4572ZM26.1289 46.8422C26.7608 46.8422 27.2094 47.219 27.2094 47.8912C27.2094 48.5447 26.7608 48.9422 26.1289 48.9422C25.4975 48.9422 25.0489 48.5648 25.0489 47.8912C25.0489 47.2397 25.4975 46.8422 26.1289 46.8422ZM25.3344 50.189H26.8836V58.9031H25.3344V50.189ZM30.7156 58.9031H29.2076V50.189H30.7161V51.7143C31.2472 50.6836 32.1444 49.9514 33.8965 50.0503V51.5165C31.9194 51.3187 30.7161 51.892 30.7161 53.7544L30.7156 58.9031ZM41.1364 57.3375C40.565 58.4873 39.4845 59.0812 38.0965 59.0812C35.713 59.0812 34.5097 57.1195 34.5097 54.5451C34.5097 52.0898 35.7729 50.0114 38.2817 50.0114C39.5853 50.0114 40.6053 50.5847 41.1364 51.7143V50.189H42.6856V58.9031H41.1364V57.3375ZM38.5053 57.6947C39.8914 57.6947 41.1144 56.8434 41.1144 54.9023V54.21C41.1144 52.2694 39.994 51.4176 38.6679 51.4176C36.9359 51.4176 36.0383 52.5258 36.0383 54.5451C36.0589 56.6451 36.9158 57.6947 38.5053 57.6947Z",
    fill: "#253858"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_516_480",
    x1: 40.9032,
    y1: 11.6966,
    x2: 31.8961,
    y2: 20.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_516_480",
    x1: 31.022,
    y1: 22.3068,
    x2: 20.6078,
    y2: 32.4389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraOriginalWordmark);
export default __webpack_public_path__ + "static/media/jira-original-wordmark.773be9253682792c463b240832a18c00.svg";
export { ForwardRef as ReactComponent };